import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { FunnelTypes } from '../../co-pilot/co-pilot.types';
import PaiButton from '../../ui/base-components/pai-button';
import PaiMenuItem from '../../ui/base-components/pai-menu-item';
import PaiSelect from '../../ui/base-components/pai-select';
import PaiTextField from '../../ui/base-components/pai-text-field';

interface Props {
  open: boolean;
  loading: boolean;
  libraryName: string;
  selectedFunnelType: FunnelTypes;

  handleLibraryNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleSelectedFunnelTypeChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleEditLibrary(): void;
}

const EditLibraryDialog: React.FC<Props> = ({
  open,
  loading,
  libraryName,
  selectedFunnelType,
  handleLibraryNameChange,
  handleSelectedFunnelTypeChange,
  handleClose,
  handleEditLibrary,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const options = [
    { label: t('hrBoosterAutoCampaignProduct'), value: FunnelTypes.ACTIVE_SOURCING_CO_PILOT },
    { label: t('leadBoosterAutoCampaignProduct'), value: FunnelTypes.SOCIAL_SELLING_CO_PILOT },
  ];

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('editLibrary')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <PaiTextField value={libraryName} label={t('libraryName')} placeholder={t('enterLibraryNameHere')} onChange={handleLibraryNameChange} />
          <PaiSelect value={selectedFunnelType} label={t('campaignType')} onChange={handleSelectedFunnelTypeChange}>
            {options.map((option) => (
              <PaiMenuItem key={option.value} value={option.value}>
                {option.label}
              </PaiMenuItem>
            ))}
          </PaiSelect>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton
          text={t('ok')}
          action={handleEditLibrary}
          disabled={libraryName.trim() === '' || !selectedFunnelType || loading}
          loading={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    background: theme.palette.primary.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '16px !important',
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default EditLibraryDialog;
